// extracted by css-extract-rspack-plugin
export default {"list":"obmdb8"};